module.exports = require("deepcopy");


//////////////////
// WEBPACK FOOTER
// external "deepcopy"
// module id = 4
// module chunks = 0